import { render, staticRenderFns } from "./reverse-relevance.vue?vue&type=template&id=487e40ad&scoped=true&"
import script from "./reverse-relevance.vue?vue&type=script&lang=ts&"
export * from "./reverse-relevance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e40ad",
  null
  
)

export default component.exports